import { useDisclosure } from "@chakra-ui/react";
import { WidgetProps } from "@rjsf/utils";
import { useId, useRef, useState } from "react";

import { useAnimationFrame } from "@nens/react/hooks";

export const useEnumOrInput = ({ schema, uiSchema, value, onChange }: WidgetProps) => {
  const options = (
    schema.enum?.map((option, idx) => ({
      value: option + "",
      label: (uiSchema?.["ui:enumNames"]?.[idx] ?? option) + "",
    })) || []
  )
    .filter(
      (option) =>
        !value ||
        option.value?.toLowerCase()?.includes(value.toLowerCase()) ||
        option.label?.toLowerCase()?.includes(value.toLowerCase())
    )
    .filter((_, index) => index < 20);

  const [isSearching, setIsSearching] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const id = useId();

  const ensureFocus = () => {
    if (inputRef.current === null) return;
    if (isOpen && document.activeElement !== inputRef.current) {
      inputRef.current.focus();
      onOpen();
    }
    if (!isOpen && document.activeElement === inputRef.current) {
      if (isSearching) {
        onClose();
        setIsSearching(false);
      }
    }
  };

  useAnimationFrame(ensureFocus, 60);

  const startSearching = () => {
    onOpen();
    if (!isSearching) {
      setIsSearching(true);
    }
  };

  const onSearchValueChanged = (newValue: string) => {
    onOpen();
    onChange(newValue);
    setIsSearching(true);
  };

  return {
    options,
    isSearching,
    isOpen,
    onClose,
    wrapperRef,
    inputRef,
    id,
    startSearching,
    onSearchValueChanged,
  };
};
